const getCurrentSeason = () => {
	const currentDate = new Date();
	const currentMonth = currentDate.getMonth() + 1;
	const currentDay = currentDate.getDate();

	if (currentMonth >= 12 || currentMonth <= 2 || (currentMonth === 3 && currentDay <= 10)) {
		return "Winter";
	} else if (currentMonth >= 3 && currentMonth <= 5) {
		return "Frühling";
	} else if (currentMonth >= 6 && currentMonth <= 8) {
		return "Sommer";
	} else {
		return "Herbst";
	}
};

export default getCurrentSeason;
